module.exports = __webpack_public_path__ + "static/media/re.90fb00ee.svg";